/* eslint-disable jsx-a11y/alt-text */
import { CardMain } from "../../../components/card/CardMain";

import { useEffect, useState } from "react";
import { MiltiSlider } from "../../../components/slider/Slider.Main";
import {
  STYLE_INPUT,
  STYLE_INPUT_ERROR,
  STYLE_INPUT_SLIDER,
  STYLE_SPACE_Y,
} from "../../../utils/useStyle";

import { NumericFormat } from "react-number-format";
import { useRetireStore } from "../../../_store/retireStore";
import { InfoDrawer } from "../../../components/drawer/InfoDrawer";
import ErrorMain from "../../../components/error/Error.Main";
import { SliderSingle } from "../../../components/slider/SliderSingle";
import { ICON_INFO, ICON_TAIL_ARROW_RIGHT } from "../../../utils/useIcons";
import { useNavigate } from "react-router-dom";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";

export const DrawerSalary = ({ openSalary, setOpenSalary }) => {
  return (
    <InfoDrawer
      open={openSalary}
      head="เงินเดือน"
      text={
        "ค่าจ้างหรือค่าตอบแทนที่บริษัทจ่ายให้กับผู้ปฏิบัติงาน ซึ่งจ่ายเป็นประจำทุกเดือน เพื่อตอบแทนการปฏิบัติหน้าที่ตามความรับผิดชอบ จูงใจให้พนักงานปฏิบัติงานได้อย่างเต็มประสิทธิภาพ มีการใช้ความรู้ความสามารถทำงานให้กับองค์กรได้อย่างเต็มที่"
      }
      onClose={() => {
        setOpenSalary(false);
      }}
    />
  );
};

export const AgeInfo = ({ openAgeInfo, setOpenAgeInfo }) => {
  return (
    <InfoDrawer
      open={openAgeInfo}
      head="อายุ"
      text={
        "อายุปัจจุบันคืออายุของคุณในปัจจุบัน และอายุเกษียณคืออายุที่ครบกําหนดอายุรับราชการหรือสิ้นกําหนดเวลารับราชการ โดยเฉลี่ยอยู่ที่ 60ปี และอายุขัยคืออายุ ที่คาดว่าจะมีชีวิตอยู่ได้อีก โดยเฉลี่ยอยู่ที่ 80 ปี"
      }
      onClose={() => {
        setOpenAgeInfo(false);
      }}
    />
  );
};

export const SalaryPerYearInfo = ({ openSalaryInfo, setOpenSalaryInfo }) => {
  return (
    <InfoDrawer
      open={openSalaryInfo}
      head="เงินเดือนที่เพิ่มขึ้นต่อปี"
      text={
        " ค่าจ้างหรือค่าตอบแทนที่บริษัทจ่ายให้กับผู้ปฏิบัติงาน ซึ่งจ่ายเป็นประจำทุกเดือน โดยเปอร์เซ็นต์ของเงินเดือนที่เพิ่มขึ้นต่อปี โดยเฉลี่ย ประมาณ 3-5% ต่อปี "
      }
      onClose={() => {
        setOpenSalaryInfo(false);
      }}
    />
  );
};

const numberWithoutComma = (value) => {
  let result = parseInt(value?.replace(/,/g, ""), 10);
  return result;
};

const ViewProfile = ({
  onClickSalary,
  onClickSalaryPerYear,
  onClick,
  userData,
  formRetire,
  setFormRetire,
  error,
  setError,
  setOpenAgeInfo,
  setOpenSalary,

  setOpenSalaryInfo,
}) => {
  const retireData = useRetireStore((state) => state.retireData);
  const setRetireData = useRetireStore((state) => state.setRetireData);

  const futurePlan = useFuturePlanStore((state) => state.futurePlanData);
  const setFuturePlanData = useFuturePlanStore(
    (state) => state.setFuturePlanData
  );

  const [openInfo, setOpenInfo] = useState(false);
  const router = useNavigate();

  const onChangeCurrentAge = (e) => {
    const value = Number(e.target.value) ? Number(e.target.value) : null;

    if (isNaN(e.target.value)) return;

    setAge(Number(e?.target?.value));
    setFormRetire({
      ...formRetire,
      age_current: value,
    });
    setRetireData({
      ...formRetire,
      age_current: value,
    });

    setFuturePlanData({
      ...futurePlan,
      age_current: value,
    });
  };

  const onChangeRetireAge = (e) => {
    const value = Number(e.target.value) ? Number(e.target.value) : null;
    if (value > 120) return;

    if (value >= formRetire.age_current) {
      setError({
        ...error,
        age_retire: true,
      });
    }

    setError({
      ...error,
      age_retire: false,
    });

    if (isNaN(e.target.value)) return;
    setFormRetire({
      ...formRetire,
      age_retire: value,
      strategy_age_retire: value,
    });
    setRetireData({
      ...formRetire,
      age_retire: value,
      strategy_age_retire: value,
    });

    setFuturePlanData({
      ...futurePlan,
      age_retire: value,
    });
  };

  const onChangeDeadAge = (e) => {
    const value = Number(e.target.value) ? Number(e.target.value) : null;

    if (value >= formRetire.age_current || value >= formRetire.age_retire) {
      setError({
        ...error,
        age_dead: true,
      });
    }

    setError({
      ...error,
      age_dead: false,
    });

    if (isNaN(e.target.value)) return;
    setFormRetire({
      ...formRetire,
      age_dead: value,
      strategy_age_dead: value,
    });
    setRetireData({
      ...formRetire,
      age_dead: value,
      strategy_age_dead: value,
    });

    setFuturePlanData({
      ...futurePlan,
      age_dead: value,
    });
  };

  const onChangeSalary = (e) => {
    const value = e.target.value;
    let outputSalary = numberWithoutComma(value);
    // Default Out Come
    let outputOutCome = outputSalary * 0.8;

    if (value > 100000000) {
      return;
    } else {
      setError({
        ...error,
        salary: false,
        out_come: false,
      });
    }

    if (value) {
      setFormRetire({
        ...formRetire,
        salary: outputSalary,
        out_come: outputOutCome,
      });
      setRetireData({
        ...formRetire,
        salary: outputSalary,
        out_come: outputOutCome,
      });

      setFuturePlanData({
        ...futurePlan,
        salary: outputSalary,
      });
    } else {
      setFormRetire({
        ...formRetire,
        salary: "",
        out_come: 0,
      });
      setRetireData({
        ...formRetire,
        salary: "",
        out_come: 0,
      });
    }
  };

  const onChangeSalaryPerYear = (e) => {
    if (isNaN(e.target.value)) return;
    // if (Number(e.target.value) > formRetire?.salary_peryear_max) return;
    if (Number(e.target.value) > 100) return;

    else {
      setError({
        ...error,
        salary_peryear: false,
      });
    }

    setFormRetire({
      ...formRetire,
      salary_peryear: e.target.value ? Number(e.target.value) : null,
      strategy_salary_peryear: e.target.value ? Number(e.target.value) : null,
    });
    setRetireData({
      ...formRetire,
      salary_peryear: e.target.value ? Number(e.target.value) : null,
      strategy_salary_peryear: e.target.value ? Number(e.target.value) : null,
    });

    setFuturePlanData({
      ...futurePlan,
      salary_peryear: e.target.value ? Number(e.target.value) : null,
    });
  };

  const onChangeOtherIncome = (e) => {
    let value = e.target.value;
    let clean = Number(value.replace(/,/g, ""));

    if (isNaN(clean)) return;
    // if (Number(e.target.value) > formRetire?.other_income_peryear_max) return;
    else {
      setError({
        ...error,
        other_income: false,
      });
    }

    // console.log("dddd", e.target.value);

    setFormRetire({
      ...formRetire,
      other_income: clean ? clean : null,
    });
    setRetireData({
      ...formRetire,
      other_income: clean ? clean : null,
    });

    setFuturePlanData({
      ...futurePlan,
      other_income: clean ? clean : null,
    });
  };

  const onChangeOtherIncomePerYear = (e) => {
    if (isNaN(e.target.value)) return;
    // if (Number(e.target.value) > formRetire?.other_income_peryear_max) return;
    if (Number(e.target.value) > 100) return;

    else {
      setError({
        ...error,
        other_income_peryear: false,
      });
    }

    setFormRetire({
      ...formRetire,
      other_income_peryear: e.target.value ? Number(e.target.value) : null,
    });
    setRetireData({
      ...formRetire,
      other_income_peryear: e.target.value ? Number(e.target.value) : null,
    });
    setFuturePlanData({
      ...futurePlan,
      other_income_growth: e.target.value ? Number(e.target.value) : null,
    });
  };

  const onChangeOtherIncomePerYearMax = (e) => {
    if (isNaN(e.target.value)) return;
    if (e.target.value > 20) return;
    if (e.target.value < formRetire?.other_income_peryear) return;
    else {
      setError({
        ...error,
        other_income_peryear_max: false,
      });
    }
    setFormRetire({
      ...formRetire,
      other_income_peryear_max: e.target.value ? Number(e.target.value) : null,
    });
    setRetireData({
      ...formRetire,
      other_income_peryear_max: e.target.value ? Number(e.target.value) : null,
    });

    setFuturePlanData({
      ...futurePlan,
      other_income_growth_max: e.target.value ? Number(e.target.value) : null,
    });
  };

  // ต้องเก็บ marker พร้อมระยะเวลา เพราะตัวเลข 1 อย่างเดียวแยก legacy default
  // ออกจากค่าหนึ่งปีที่ผู้ใช้ตั้งเองไม่ได้
  const onChangeOtherIncomeLength = (e) => {
    if (isNaN(e.target.value)) return;
    // if (Number(e.target.value) > formRetire?.other_income_length_max) return;
    if (Number(e.target.value) > 100) return;

    else {
      setError({
        ...error,
        other_income_length: false,
      });
    }

    setFormRetire({
      ...formRetire,
      other_income_length: e.target.value ? Number(e.target.value) : null,
      other_income_length_is_explicit: true,
    });
    setRetireData({
      ...formRetire,
      other_income_length: e.target.value ? Number(e.target.value) : null,
      other_income_length_is_explicit: true,
    });

    setFuturePlanData({
      ...futurePlan,
      salary_peryear_duration: e.target.value ? Number(e.target.value) : null,
      salary_peryear_duration_is_explicit: true,
    });
  };

  const onChangeOtherIncomeLengthMax = (e) => {
    if (isNaN(e.target.value)) return;
    if (e.target.value > 20) return;
    if (e.target.value < formRetire?.other_income_length) return;
    else {
      setError({
        ...error,
        other_income_length_max: false,
      });
    }
    setFormRetire({
      ...formRetire,
      other_income_length_max: e.target.value ? Number(e.target.value) : null,
    });
    setRetireData({
      ...formRetire,
      other_income_length_max: e.target.value ? Number(e.target.value) : null,
    });

    setFuturePlanData({
      ...futurePlan,
      salary_peryear_duration_max: e.target.value
        ? Number(e.target.value)
        : null,
    });
  };

  const onChangeSalaryPerYearMax = (e) => {
    if (isNaN(e.target.value)) return;
    if (e.target.value > 20) return;
    if (e.target.value < formRetire?.salary_peryear) return;
    else {
      setError({
        ...error,
        salary_peryear_max: false,
      });
    }
    setFormRetire({
      ...formRetire,
      salary_peryear_max: e.target.value ? Number(e.target.value) : null,
    });
    setRetireData({
      ...formRetire,
      salary_peryear_max: e.target.value ? Number(e.target.value) : null,
    });

    setFuturePlanData({
      ...futurePlan,
      salary_peryear_max: e.target.value ? Number(e.target.value) : null,
    });
  };

  const [age, setAge] = useState([
    formRetire?.age_current,
    formRetire?.age_retire,
    formRetire?.age_dead,
  ]);

  const onChangeAge = (e) => {
    // console.log("AA:", e);
    setAge(e);
    setFormRetire({
      ...formRetire,
      age_current: e[0],
      age_retire: e[1],
      age_dead: e[2],
    });
  };

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      setFormRetire({
        ...formRetire,
        salary_peryear: formRetire?.salary_peryear,
      });
    }
  }, [formRetire?.salary_peryear_max]);

  const AgeInformation = () => {
    return <div></div>;
  };

  return (
    <>
      <div className={STYLE_SPACE_Y}>
        <CardMain
          onClick={() => {
            setOpenAgeInfo(true);
          }}
          icon={true}
          title="อายุ"
          panel={
            <div className=" px-[7px] ">
              <div className=" grid grid-cols-3 justify-center items-center">
                <div className=" mx-auto flex flex-col justify-center items-center gap-1">
                  <img
                    src="/images/present_age2.png"
                    className=" mx-auto w-[50px] h-[50px]"
                  />
                  <div className="mt-2 text-sm font-semibold text-maincyan">
                    อายุปัจจุบัน
                  </div>
                  <NumericFormat
                    maxLength={3}
                    placeholder="0"
                    pattern="[0-9],*"
                    className={STYLE_INPUT_SLIDER}
                    value={formRetire.age_current}
                    onChange={onChangeCurrentAge}
                  />
                </div>
                <div className=" mx-auto flex flex-col justify-center items-center gap-1">
                  <img
                    src="/images/old_age2.png"
                    className=" mx-auto w-[50px] h-[50px]"
                  />
                  <div className="mt-2 text-sm font-semibold text-[#B95940]">
                    อายุเกษียณ
                  </div>
                  <NumericFormat
                    maxLength={3}
                    placeholder="0"
                    pattern="[0-9],*"
                    className={STYLE_INPUT_SLIDER}
                    value={formRetire.age_retire}
                    onChange={onChangeRetireAge}
                  />
                </div>
                <div className=" mx-auto flex flex-col justify-center items-center gap-1">
                  <img
                    src="/images/dead2.png"
                    className=" mx-auto w-[50px] h-[50px]"
                  />
                  <div className="mt-2 text-sm font-semibold text-mainorange">
                    สิ้นอายุขัย
                  </div>
                  <NumericFormat
                    maxLength={3}
                    placeholder="0"
                    pattern="[0-9],*"
                    className={STYLE_INPUT_SLIDER}
                    value={formRetire?.age_dead}
                    onChange={onChangeDeadAge}
                  />
                </div>
              </div>
              <div className=" pt-4 w-full">
                <MiltiSlider
                  onChange={onChangeAge}
                  current={formRetire?.age_current}
                  retire={formRetire?.age_retire}
                  dead={formRetire?.age_dead}
                  maxdead={120}
                />
              </div>
              {(error?.age_current || error?.age_retire || error?.age_dead) && (
                <div className=" pt-4 w-full">
                  <ErrorMain errortext="กรุณากรอกอายุให้ถูกต้อง ตามเงื่อนไข อายุปัจจุบัน <= อายุเกษียณ < อายุขัย" />
                </div>
              )}
            </div>
          }
        />
        <CardMain
          onClick={() => {
            setOpenSalary(true);
          }}
          icon={false}
          title="เงินเดือน (บาท/เดือน) "
          margin=""
          mb="mb-[21px]"
          panel={
            <div className=" px-2">
              <NumericFormat
                value={formRetire?.salary}
                onChange={onChangeSalary}
                maxLength={11}
                placeholder="25,000"
                thousandSeparator=","
                inputMode="decimal"
                pattern="[0-9],*"
                className={error?.salary ? STYLE_INPUT_ERROR : STYLE_INPUT}
              />
              {error?.salary && (
                <ErrorMain errortext="กรุณากรอกเงินเดือน ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
              )}
            </div>
          }
        />
        <CardMain
          onClick={() => {
            setOpenSalaryInfo(true);
          }}
          icon={false}
          title="เงินเดือนที่เพิ่มขึ้นต่อปี (%)"
          margin=""
          mb="mb-2.5"
          panel={
            <div className=" px-4">
              <div className=" flex justify-center">
                <NumericFormat
                  maxLength={11}
                  min={1}
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  placeholder="0"
                  className={STYLE_INPUT_SLIDER}
                  value={formRetire?.salary_peryear}
                  onChange={onChangeSalaryPerYear}
                />
              </div>
              <SliderSingle
                placeholder="0"
                // valuemax={formRetire?.salary_peryear_max}
                valuemax={100}
              disabledMax={true}
                value={formRetire?.salary_peryear}
                onChange={onChangeSalaryPerYear}
                onChnageMax={onChangeSalaryPerYearMax}
                valuemin={1}
              />
              {error?.salary_peryear && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
              )}
              {error?.salary_peryear_max && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี" />
              )}
            </div>
          }
        />
        {userData?.is_premium && (
          <CardMain
            onClick={() => {
              setOpenSalary(true);
            }}
            icon={false}
            title={
              <div className="flex space-x-[6px]">
                <div>รายรับอื่น ๆ ต่อเดือน</div>
                <div>
                  <ICON_INFO
                    onClick={() => {
                      setOpenInfo(true);
                    }}
                    className={` w-4 h-4 text-maingray mt-1`}
                  />
                </div>
              </div>
            }
            margin=""
            mb="mb-[21px]"
            panel={
              <div className=" px-2">
                <NumericFormat
                  value={formRetire?.other_income}
                  onChange={onChangeOtherIncome}
                  decimalScale={2}
                  maxLength={11}
                  placeholder="25,000"
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  className={
                    error?.other_income ? STYLE_INPUT_ERROR : STYLE_INPUT
                  }
                />
                {error?.other_income && (
                  <ErrorMain errortext="กรุณากรอกเงินเดือน ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
                )}
              </div>
            }
          />
        )}
        {userData?.is_premium && <CardMain
          onClick={() => {
            setOpenSalaryInfo(true);
          }}
          icon={false}
          title="รายรับอื่น ๆ ที่เพิ่มขึ้นต่อปี"
          margin=""
          mb="mb-2.5"
          panel={
            <div className=" px-4">
              <div className=" flex justify-center">
                <NumericFormat
                  maxLength={11}
                  min={1}
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  placeholder="0"
                  className={STYLE_INPUT_SLIDER}
                  value={formRetire?.other_income_peryear}
                  onChange={onChangeOtherIncomePerYear}
                />
              </div>
              <SliderSingle
                placeholder="0"
                // valuemax={formRetire?.other_income_peryear_max}
                valuemax={100}
              disabledMax={true}
                value={formRetire?.other_income_peryear}
                onChange={onChangeOtherIncomePerYear}
                onChnageMax={onChangeOtherIncomePerYearMax}
                valuemin={1}
              />
              {error?.salary_peryear && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
              )}
              {error?.salary_peryear_max && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี" />
              )}
            </div>
          }
        />}
        {userData?.is_premium && <CardMain
          onClick={() => {
            setOpenSalaryInfo(true);
          }}
          icon={false}
          title="คาดการณ์ระยะเวลาที่จะมีรายรับอื่น ๆ"
          margin=""
          mb="mb-2.5"
          panel={
            <div className=" px-4">
              <div className=" flex justify-center">
                <NumericFormat
                  maxLength={11}
                  min={1}
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  placeholder="0"
                  className={STYLE_INPUT_SLIDER}
                  value={formRetire?.other_income_length}
                  onChange={onChangeOtherIncomeLength}
                />
              </div>
              <SliderSingle
                placeholder="0"
                // valuemax={formRetire?.other_income_length_max}
                valuemax={100}
              disabledMax={true}
                value={formRetire?.other_income_length}
                onChange={onChangeOtherIncomeLength}
                onChnageMax={onChangeOtherIncomeLengthMax}
                valuemin={1}
                year={true}
              />
              {error?.salary_peryear && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
              )}
              {error?.salary_peryear_max && (
                <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี" />
              )}
            </div>
          }
        />}
      </div>
      {openInfo && (
        <InfoDrawer
          bottom="bottom-[-60%]"
          head={"รายรับอื่น ๆ"}
          className={" !max-h-[471px] !h-[471px] "}
          text={
            <div className=" space-y-2">
              <div>
                คือ รายรับจากดอกเบี้ย ธุรกิจรับเหมา วิชาชีพเฉพาะ ค่าลิขสิทธิ
                สิทธิบัตร โบนัส เงินปันผล ค่านายหน้า ค่าเช่าอสังหาฯ
                รายรับจากการขายสินทรัพย์ อื่นๆ
              </div>
              {/* <div className="flex items-center space-x-2 ">
                <div className="font-semibold text-base text-[#18488A] ">
                  ปรับกลยุทธ์ใหม่
                </div>
                <ICON_TAIL_ARROW_RIGHT
                  onClick={() => {
                    router("/balance");
                  }}
                />
              </div> */}
            </div>
          }
          ishaveBtn={false}
          open={openInfo}
          onClose={() => {
            setOpenInfo(false);
          }}
        />
      )}
    </>
  );
};
export default ViewProfile;
